import * as React from 'react';
import * as adv from "./style.module.scss";
import { ExpertLicenses } from "../../../../ExpertLicenses";
import { Licenses } from "../../../../Licenses";
import { AdvanceRocket } from "../../../../AdvanceRocket";
export const Advance = () => {
  return (
    <>
      <AdvanceRocket bgColor={"#F2F3F7"}/>
      <section className={adv.adv}>
        <div className={'container'}>
          <div className={adv.adv__top}>
            <h3 className={adv.adv__title}>Нас ценят эксперты образования</h3>
            <ExpertLicenses/>
          </div>

          <div className={adv.adv__bottom}>
            <h3 className={adv.adv__title}>Мы развиваем образование</h3>
            <Licenses/>
          </div>
        </div>
      </section>
    </>
  );
};
